<template>
  <list-layout :tableTools='toggleTableTools'>
    <template slot='header'>
      <BaseHeader :content='header' data-v-step="4"/>
    </template>
    <template slot='table-core'>
      <base-table-pagination
        ref="baseTablePagRef"
        :total='pagination.total'
        :currentPage='pagination.currentPage'
        :perPage='pagination.pageSize'
        @changeCurrentPage='changeCurrentPage'
        @changePerPage='changePerPage'
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-refresh @applyFilters="applyFiltersHandler" />
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot='table-tags'>
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot='table-component' >
      <kendo-grid-component
        :spanish="spanish"
        :dataResult='kendo.dataResult'
        :kendo="kendo"
        :loading='isGeneralLoading'
        :selectedField="selectedField"
        @datastatechange='dataStateChange'
        @columnreorder='columnReorder'
        @rowclick='openPath'
        @columnssubmit='onColumnsSubmit'
        @sortchange='sortChange'
        @filterchange='filterChange'
        @selectionchange="onSelectionChange"
        @headerselectionchange="onHeaderSelectionChange">
      </kendo-grid-component>
    </template>
    <template slot='layout-extend'>
      <base-table-select-actions-expand
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
        :baseDropDownVisible="accionesEmpresasFinal !== null && accionesEmpresasFinal.length > 0 && hasSelected"
      >
        <template slot="commons">
          <base-button :disabled="!hasSelected" size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" :ariaHidden="true"/>
            {{ $t('app.unselect') }}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in accionesEmpresasFinal" :key="action.idKey">
              <base-button-item-list theme="dark"  @click="executeAction(action)">
                  <base-icon :name="selectIcon(action)" class="mr-2" :ariaHidden="true"/>
                    <div class="w-56 text-left">
                      {{ action.name }}
                    </div>
            </base-button-item-list>
          </span>
          <!-- <span>
             <base-button-item-list theme="dark" @click="deleteCompany">
              <base-icon name="trash" class="mr-2" :ariaHidden="true"/>
              Borrar2
            </base-button-item-list>
          </span> -->
        </template>
      </base-table-select-actions-expand>
      <base-footer>
        <template slot='actions'>
          <div class='mt-5 mb-5'></div>
          <base-button-responsive 
            v-if="exportPgnsVisible"
            mode='primary' :text="labelBtnExcelPgns" icon='excelxls' @click='exportExcelPgns' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive v-if="hasModuleImportaciones && !isRoleUserOrConsulta" mode='primary' :text="$t('app.import')" icon='import' @click='toggleImport' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive v-if="!isRoleUserOrConsulta" mode="primary" :text="$t('companies.new_company')" icon="plus" @click="goToNewCompany" :loading="isGeneralLoading"/>
        </template>
      </base-footer>
      <import-generic-dialog
        :vuexNamespace="vuexnamespace"
        :dialogOpen="showModalImport" 
        :mandatoryClient="true"
        :activateSwitch1="true"
        :labelSwitch1="$t('app.excel_import_options_update')"
        :activateSwitch2="true"
        :labelSwitch2="$t('app.excel_import_options_update_pgns')"
        :sizeLg="role !== 'Administrador'"
        @toggleDialog="toggleImport" 
        @applyDialog="applyImport"
        @downloadTemplate="downloadTemplate"
        header="Importación de Empresas" 
        />      
      <company-grouping-dialog 
        :dialogOpen="showModalGrouping" 
        @toggleDialog="toggleModalGrouping" 
        @applyDialog="applyModalGrouping"
        header="Vincular a agrupación" 
        headerValue="Nombre de la agrupación" 
        :idCliente="selectedIdEmpresa"
        />
      <BaseElDialog
            title="Borrar empresa"
            :visible.sync="showModal"
            @open="handleOpenModalDialog('container-handleOpenModal-delete')"
            @closed="releaseFocusDialog"
            width="40%"
            custom-class="min-width-dialog"
            center
            :show-close="false">
            <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
            <template slot="footer" >
              <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-delete">
                <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
                <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModal = false}"/>
              </div>
            </template>
        </BaseElDialog>
      <filter-panel :panelOpen='filterPanel' @togglePanel='toggleFilters' @applyFilters='applyFiltersHandler' />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import { bus } from '@/main'
import { ACCIONES_EMPRESAS } from '@/config/acciones-empresas'

import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/CompaniesFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import ImportGenericDialog from '@/components/ImportGenericDialog.vue'

import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import CompanyGroupingDialog from '@/components/CompanyGroupingDialog.vue'
import { getCompanies } from '@/services/companies/getCompanies'
import { i18n } from '@/i18n'
import { process } from '@progress/kendo-data-query'
// import { saveExcel } from '@progress/kendo-vue-excel-export'
import KendoGridComponent from '../../components/KendoGridComponent.vue'
// import moment from 'moment'

import { downloadExcel } from '@/services/companies/downloadExcel'
import { downloadExcelPgns } from '@/services/companies/downloadExcelPgns'
import { load } from '@progress/kendo-vue-intl'
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json'
import currencyData from 'cldr-core/supplemental/currencyData.json'
import weekData from 'cldr-core/supplemental/weekData.json'
import numbers from 'cldr-numbers-full/main/es/numbers.json'
import currencies from 'cldr-numbers-full/main/es/currencies.json'
import caGregorian from 'cldr-dates-full/main/es/ca-gregorian.json'
import dateFields from 'cldr-dates-full/main/es/dateFields.json'
import timeZoneNames from 'cldr-dates-full/main/es/timeZoneNames.json'
import BaseElDialog from '@/components/base/BaseElDialog.vue'
// import { deleteCompany } from '@/services/companies/deleteCompany'
import { updateStateCompanies } from '@/services/companies/updateStateCompanies'
import { retryCourtesyDaysAEAT } from '@/services/companies/retryCourtesyDaysAEAT'
import { cancelCourtesyDaysAEAT } from '@/services/companies/cancelCourtesyDaysAEAT'
import { cancelConsultaCourtesyDaysAEAT } from '@/services/companies/cancelConsultaCourtesyDaysAEAT'

import { linkGroupingCompaniesName } from '@/services/configurations/grouping/linkGroupingCompaniesName'

import { importCompanies } from '@/services/configurations/imports/importCompanies'
import { downloadTemplateCompanies } from '@/services/configurations/imports/downloadTemplateCompanies'
import { quitarAlertaDesactivada } from '@/services/notifications/quitarAlertaDesactivada'
import { cancelAlertPoderesDelegados } from '@/services/notifications/cancelAlertPoderesDelegados'

load(
  likelySubtags,
  currencyData,
  weekData,
  numbers,
  currencies,
  caGregorian,
  dateFields,
  timeZoneNames
)

export default {
  name: 'list-view',
  components: {
    ListLayout,
    CompanyGroupingDialog,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
    BaseElDialog,
    ImportGenericDialog,
  },
  data: function () {
    return {
      idVista: 4,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // Import
      showModalImport: false,
      // All
      showModalGrouping: false,
      accionesEmpresas: ACCIONES_EMPRESAS,
      loadingExcel: false,
      spanish: true,
      showModal: false,
      header: {
        title: i18n.t('app.companies'),
        icon: 'companies',
        breadcrumb: null,
        url: null
      },
      vuexnamespace: 'companies',
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selected: [],
      processMessage: '¿Estás seguro que deseas borrar las empresas seleccionadas?'
    }
  },
  computed: {
    exportPgnsVisible () {
      if (this.role === 'Administrador' || this.role === 'Usuario' || this.role === 'UsuarioConsulta') return true
      if (this.hasSelected) {
        const idEmpresa = this.selected[0].IdEmpresa
        if (this.selected.filter(x => x.IdEmpresa === idEmpresa).length === this.selected.length) return true
        return false
      } else {
        if (this.filterContainsClient) return true
        return false
      }
    },
    filterContainsClient () {
      return this.$store.getters[this.vuexnamespace + '/getAppliedFilters']?.empresa
    },
    hasModuleImportaciones () {
      return this.$store.getters['auth/hasModuleImportaciones']
    },
    hasModuleNotificacionesTerceros () {
      return this.$store.getters['auth/hasModuleNotificacionesTerceros'] 
    },
    selectedIdEmpresa () {
      return this.hasSelected ? this.selected[0].IdEmpresa : null
    },
    accionesEmpresasFinal () {
      let accionesFinal = this.accionesEmpresas
      if (this.hasSelected) {
        const idEmpresa = this.selected[0].IdEmpresa
        if (this.selected.filter(x => x.IdEmpresa === idEmpresa).length === this.selected.length) {
          if (!this.hasPermVacacionesAEAT) accionesFinal = accionesFinal.filter(x => x.idKey !== 9 && x.idKey !== 10 && x.idKey !== 11)
          else {
            if (this.selected.filter(x => x.EstadoVacacionesFiscalesError === true).length !== this.selected.length) {
              accionesFinal = accionesFinal.filter(x => x.idKey !== 10 && x.idKey !== 11)
            } 
            if (this.selected.filter(x => x.EstadoConsultaVacacionesFiscalesError).length !== this.selected.length) {
              accionesFinal = accionesFinal.filter(x => x.idKey !== 13)
            } 
          }
          if (!this.hasModuleAgrupaciones) accionesFinal = accionesFinal.filter(x => x.idKey !== 12)
        } else {
          accionesFinal = accionesFinal.filter(x => x.idKey !== 8 && x.idKey !== 9 && x.idKey !== 10 && x.idKey !== 11 && x.idKey !== 12)
        }
        if (this.selected.filter(x => x.AlertaEmpresaDesactivada === true).length !== this.selected.length) {
          accionesFinal = accionesFinal.filter(x => x.idKey !== 14)
        }
        if (!this.hasModuleNotificacionesTerceros && this.role === 'Administrador') {
          accionesFinal = accionesFinal.filter(x => x.idKey !== 15)
          accionesFinal = accionesFinal.filter(x => x.idKey !== 16)
        }
      }
      return accionesFinal
    },
    hasAnyImportaciones () {
      return this.$store.getters['auth/hasAnyImportaciones']
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return this.$i18n.t('app.export_excel') + ' (Seleccionados)'
      return this.$i18n.t('app.export_excel')
    },
    labelBtnExcelPgns: function () {
      if (this.hasSelected) return this.$i18n.t('companies.export_excel_pgns') + ' (Seleccionados)'
      return this.$i18n.t('companies.export_excel_pgns')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? 'Solo Seleccionadas' : 'Ver Todas'
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    hasModuleVacacionesAEAT () {
      return this.$store.getters['auth/hasModuleVacacionesAEAT']
    },
    hasPermVacacionesAEAT () {
      return this.hasModuleVacacionesAEAT && 
      (this.role === 'Administrador' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador')
    },
    hasModuleAgrupaciones () {
      return this.$store.getters['auth/hasModuleAgrupaciones']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 'Usuario' || this.role === 'UsuarioConsulta'
    },
    selectIcon: function (action) {
      return (action) =>
        action.id === 4 ? 'trash' 
          : action.id === 50 ? 'editpencil'
            : action.id === 6 ? 'vacation'
              : action.id === 7 ? 'vacationrefresh'
                : action.id === 8 || action.id === 13 ? 'vacationcancel'
                  : action.idKey === 3 ? 'mailcheck' 
                    : action.idKey === 4 ? 'mailcross' 
                      : action.idKey === 5 ? 'downloadcheck' 
                        : action.idKey === 6 ? 'downloadcancel' 
                          : action.idKey === 12 ? 'groupingadd'
                            : action.idKey === 14 ? 'belloff'
                              : action.idKey === 15 ? 'belloff'
                                : action.idKey === 16 ? 'bellon'
                                  : action.activo ? 'check' : 'cross'
    }
  },
  watch: {
    $route: 'routerChangeHandler',
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    data (val, oldVal) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group
      }
      this.kendo.dataResult = process(val, dataState)
      this.unselect()
    }
  },
  created: function () {
    if (this.isRoleUserOrConsulta) {
      this.kendo.columns = this.kendo.columns.filter(x => x.field !== 'selected')
    } 
    if (this.$route.params.data) {
      this.filterByParamsData()
    }
  },
  mounted: async function () {
    this.initialice()
  },
  methods: {
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    toggleImport () {
      this.showModalImport = !this.showModalImport
    },
    applyImport: async function (file, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const params = { 
          idCliente: form.idCliente,
          actualizarCIFS: form.switch1,
          vincularSedes: form.switch2,
        }
        const response = await importCompanies(file, params)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.toggleImport() 
          this.doFeedback('Procesando importación. Puede consultar el estado en esta vista.', 'info')
          if (!this.hasAnyImportaciones) {
            bus.$emit('resetAndUpdateNav', 1000)
          }
          this.$router.push({ name: 'configurations/imports' })
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplate: async function (formIdCliente) {
      this.$store.commit('setIsLoading', true)
      try {
        const params = {
          idCliente: formIdCliente
        }
        const response = await downloadTemplateCompanies(params)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.downloadBlob(response, 'plantilla-importacion-empresas.xlsx')
        }
      } catch (error) {
        console.error(error)
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleModalGrouping () {
      this.showModalGrouping = !this.showModalGrouping
    },
    routerChangeHandler: async function () {
      this.filterByParamsData()
      this.initialice()
    },
    initialice: async function () {
      // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
      this.data = await this.applyFilters()
    },
    filterByParamsData: function () {
      const data = this.$route.params.data
      const filters = {}
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'cliente') {
            const cliente = { label: 'Cliente', value: filter.data.label }
            filters.empresa = cliente
          } else {
            // Mantenemos filtro de cliente
            const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
            // console.log('getAppliedFilters', data)
            if (data.empresa) filters.empresa = { label: data.empresa.label, value: data.empresa.value } 
            if (filter.type === 'estadoDiasCortesiaAEATError') {
              const estadoDiasCortesiaAEATError = { label: this.$i18n.t('companies.status_solicitud_coutersy_days_error'), value: filter.data }
              filters.estadoDiasCortesiaAEATError = estadoDiasCortesiaAEATError
            } else if (filter.type === 'consultaDiasCortesiaAEATError') {
              const consultaDiasCortesiaAEATError = { label: this.$i18n.t('companies.status_query_coutersy_days_error'), value: filter.data }
              filters.consultaDiasCortesiaAEATError = consultaDiasCortesiaAEATError
            } else if (filter.type === 'alertaEmpresaDesactivada') {
              const alertaEmpresaDesactivada = { label: this.$i18n.t('companies.alertaEmpresaDesactivada'), value: filter.data }
              filters.alertaEmpresaDesactivada = alertaEmpresaDesactivada
            } else if (filter.type === 'errorHotfolder') {
              const errorHotfolder = { label: this.$i18n.t('companies.errorHotfolder'), value: filter.data }
              filters.errorHotfolder = errorHotfolder
            } else if (filter.type === 'sinVigilarHotfolder') {
              const sinVigilarHotfolder = { label: this.$i18n.t('companies.sinVigilarHotfolder'), value: filter.data }
              filters.sinVigilarHotfolder = sinVigilarHotfolder
            }
          }
        })
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filters)
      }
    },
    updateAllSelectedHeader: function () {
      if (!this.hasSelected) {
        this.kendo.columns[0].headerSelectionValue = false
      } else {
        this.kendo.columns[0].headerSelectionValue = this.areAllSelected
      }
    },
    openPath: function (event) {
      this.$store.commit('app/setheaderBreadCrumb', event.dataItem.NombreCIF)
      this.$router.push({ name: 'companies/detail', params: { id: event.dataItem.IdCIFEmpresa } })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    createAppState: function (dataState) {
      this.kendo.take = dataState.take
      this.kendo.skip = dataState.skip
      if (dataState.group) {
        // eslint-disable-next-line no-return-assign
        // dataState.group.map(group => group.aggregates = this.aggregates)
      }
      this.kendo.group = dataState.group
      this.kendo.filter = dataState.filter
      this.kendo.sort = dataState.sort
    },
    dataStateChange: async function (event) {
      this.createAppState(event.data)
      this.data = await this.applyFilters()
    },
    columnReorder: function (options) {      
      this.sendUpdatedColumns(options.columns)
      this.kendo.columns.forEach((column, index) => {
        if (options.columns.filter(x => x.field === column.field).length === 0) {
          column.orderIndex = index + this.kendo.columns.length
          options.columns.push(column)
        }
      })
      this.kendo.columns = options.columns
    },
    exportExcelPgns: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const payload = {}
      if (this.hasSelected) {
        payload.idCifsEmpresa = this.selected.map(x => x.IdCIFEmpresa)
      } else {
        if (this.filterContainsClient) {
          payload.NombreCliente = this.filterContainsClient.value
        }
      }
      try {
        const response = await downloadExcelPgns(payload)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'empresas-sedes.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const user = this.$store.getters['auth/user']
      const params = {
        idUsuario: user.IdUsuario,
        CIF: data.cif ? data.cif.value : null,
        nombre: data.name ? data.name.value : null,
        descargaAutomatica: data.automatic_download ? data.automatic_download.value : null,
        fechaAltaDesde: data.fechaAltaDesde ? data.fechaAltaDesde.value : null,
        fechaAltaHasta: data.fechaAltaHasta ? data.fechaAltaHasta.value : null,
        Distribuidor: data.distribuidor ? data.distribuidor.value : null,
        Empresa: data.empresa ? data.empresa.value : null,
        estado: data.estado ? data.estado.value : null,
        emailGenerico: data.email ? data.email.value : null,        
        numeroSMSGenerico: data.phone ? data.phone.value : null,
        enviarAvisos: data.send_alerts ? data.send_alerts.value : null,
        estadoVacacionesFiscalesError: data.estadoDiasCortesiaAEATError ? data.estadoDiasCortesiaAEATError.value : null,
        consultaVacacionesFiscalesError: data.consultaDiasCortesiaAEATError ? data.consultaDiasCortesiaAEATError.value : null,
        alertaEmpresaDesactivada: data.alertaEmpresaDesactivada ? data.alertaEmpresaDesactivada.value : null,
        certAsociado: data.certAsociado ? data.certAsociado.value : null,
        nombreAgrupacion: data.nombreAgrupacion ? data.nombreAgrupacion.value : null,
        codigoSede: data.codPGN ? data.codPGN.value : null,
        errorHotfolder: data.errorHotfolder ? data.errorHotfolder.value : null,
        sinVigilarHotfolder: data.sinVigilarHotfolder ? data.sinVigilarHotfolder.value : null,
        conPoderesDelegados: data.conPoderesDelegados ? data.conPoderesDelegados.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = { order: objOrder.order, grupos: objColumnas }
      if (this.hasSelected) {
        const selectedIDs = this.selected.map(x => x.IdCIFEmpresa)
        payload.listaIDs = selectedIDs
      }
      try {
        const response = await downloadExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'empresas.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    onColumnsSubmit: function (columnsState) {
      this.sendUpdatedColumns(columnsState)
      this.kendo.columns = columnsState
    },
    sortChange: function (e) {
      let sort = e.sort
      if (Array.isArray(e)) {
        sort = e
      }
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: sort,
        group: this.kendo.group,
        filter: this.kendo.filter
      }
      this.dataStateChange({ data: dataState })
    },
    filterChange: function (filter) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group,
        filter: filter
      }

      this.dataStateChange({ data: dataState })
    },
    expandChange: function (event) {
      event.dataItem[event.target.$props.expandField] = !event.dataItem[event.target.$props.expandField]
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const user = this.$store.getters['auth/user']
      const params = {
        idUsuario: user.IdUsuario,
        CIF: data.cif ? data.cif.value : null,
        nombre: data.name ? data.name.value : null,
        descargaAutomatica: data.automatic_download ? data.automatic_download.value : null,
        fechaAltaDesde: data.fechaAltaDesde ? data.fechaAltaDesde.value : null,
        fechaAltaHasta: data.fechaAltaHasta ? data.fechaAltaHasta.value : null,
        Distribuidor: data.distribuidor ? data.distribuidor.value : null,
        Empresa: data.empresa ? data.empresa.value : null,
        estado: data.estado ? data.estado.value : null,
        numeroSMSGenerico: data.phone ? data.phone.value : null,
        emailGenerico: data.email ? data.email.value : null,
        enviarAvisos: data.send_alerts ? data.send_alerts.value : null,
        estadoVacacionesFiscalesError: data.estadoDiasCortesiaAEATError ? data.estadoDiasCortesiaAEATError.value : null,
        consultaVacacionesFiscalesError: data.consultaDiasCortesiaAEATError ? data.consultaDiasCortesiaAEATError.value : null,
        alertaEmpresaDesactivada: data.alertaEmpresaDesactivada ? data.alertaEmpresaDesactivada.value : null,
        certAsociado: data.certAsociado ? data.certAsociado.value : null,
        nombreAgrupacion: data.nombreAgrupacion ? data.nombreAgrupacion.value : null,
        codigoSede: data.codPGN ? data.codPGN.value : null,
        errorHotfolder: data.errorHotfolder ? data.errorHotfolder.value : null,
        sinVigilarHotfolder: data.sinVigilarHotfolder ? data.sinVigilarHotfolder.value : null,
        conPoderesDelegados: data.conPoderesDelegados ? data.conPoderesDelegados.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        const data = await this.getItemsData(objOrder, params)
        this.data = data
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(this.$i18n.t('feedback.error.general'))
      }
      this.updateAllSelectedHeader()
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = res.respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      
      this.updatePersistedSortMixin()
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getCompanies(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
      } else {
        setTimeout(() => {
          this.$nextTick(() => { 
            if (this.$refs.baseTablePagRef) this.$refs.baseTablePagRef.focus() 
          })
          this.doFeedback('Se han refrescado los datos del grid actual', 'info', 3000, true)
        }, 200)
      }
      data.respuesta.forEach(o => {
        o.DiasDescargaAutomatica = o.DiasDescargaAutomatica === null ? 0 : o.DiasDescargaAutomatica
        o.DiasAviso = o.DiasAviso === null ? 'Desactivado' : o.DiasAviso
        o.DiasFinTramite = o.DiasFinTramite === null ? 'Desactivado' : o.DiasFinTramite
      })
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    tableSortByChangeHandler: function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.applyFilters(null)
    },
    deleteCompany: async function () {
      this.showModal = !this.showModal
    },
    goLinkLocation: function () {
      this.linkLocation = !this.linkLocation
    },
    unselect: function () {
      const checked = false
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onHeaderSelectionChange: function (event) {
      const checked = event.event.target.checked
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onSelectionChange: function (event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField]
      this.selected = event.dataItems.filter(d => d.selected === true)
      this.updateAllSelectedHeader()
    },
    goToNewCompany: function () {
      this.$router.push({ name: 'companies/detail', params: { id: -1 } })
    },
    deleteHandler: async function () {
      this.executeActionHandler()
    },
    executeAction: async function (action) {
      this.selectedAction = action
      // this.executeActionHandler()
      if (this.selectedAction.id === 4) { // borrar
        this.showModal = true
      } else if (this.selectedAction.id === 50) { // Plantilla modo por campos
        const data = {
          companies: this.selected.map(x => x.IdCIFEmpresa)
        }
        const idEmpresa = this.selected.map(x => x.IdEmpresa)[0]
        if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
          this.$router.push({ name: 'configurations/clients/template/companies', params: { data: data, id: idEmpresa } })
        } else {
          this.$router.push({ name: 'configurations/template/companies', params: { data: data } })
        } 
      } else if (this.selectedAction.id === 6) {
        const dataFilters = { filters: [] }
        dataFilters.filters.push({ type: 'companies', data: this.selected.map(x => x.IdCIFEmpresa) })
        if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
          this.$router.push({ name: 'configurations/clients/courtesydaysaeat', params: { id: this.selected[0].IdEmpresa, data: dataFilters } })
        } else if (this.role === 'Administrador') {
          this.$router.push({ name: 'configurations/courtesydaysaeat', params: { id: this.selected[0].IdEmpresa, data: dataFilters } })
        }
      } else if (this.selectedAction.id === 7) {
        this.retryCourtesyDaysAEATHandler()
      } else if (this.selectedAction.id === 8) {
        this.cancelCourtesyDaysAEATHandler()
      } else if (this.selectedAction.id === 13) {
        this.cancelCourtesyDaysAEATHandler(true)
      } else if (this.selectedAction.id === 12) {
        this.toggleModalGrouping()
      } else if (this.selectedAction.id === 14) {
        this.remmoveErrorEmpresaDesactivada()
      // } else if (this.selectedAction.id === 15) {
      //   this.cancelAlertPoderesDelegados()
      } else {
        this.executeActionHandler()
      } 
    },
    executeAlertAction: async function (serviceFn) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idCifsEmpresa: this.selected.map(el => el.IdCIFEmpresa) }
        const response = await serviceFn(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.$store.dispatch('app/getAnnouncementsList')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        await this.applyFilters()
      }
    },
    cancelAlertPoderesDelegados: async function () {
      await this.executeAlertAction(cancelAlertPoderesDelegados)
    },
    remmoveErrorEmpresaDesactivada: async function () {
      await this.executeAlertAction(quitarAlertaDesactivada)
    },
    applyModalGrouping: async function (nombre) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { Nombre: nombre, idCifEmpresas: [] }
        const selected = this.selected
        selected.forEach((s) => {
          payload.idCifEmpresas.push(s.IdCIFEmpresa)
        })
        const response = await linkGroupingCompaniesName(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.toggleModalGrouping()
          await this.applyFilters()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    retryCourtesyDaysAEATHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const idCIFS = []
        const selected = this.selected
        selected.forEach((s) => {
          idCIFS.push(s.IdCIFEmpresa)
        })
        const response = await retryCourtesyDaysAEAT(idCIFS)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        await this.applyFilters()
      }
    },
    cancelCourtesyDaysAEATHandler: async function (consulta = false) {
      try {
        this.$store.commit('setIsLoading', true)
        const idCIFS = []
        const selected = this.selected
        selected.forEach((s) => {
          idCIFS.push(s.IdCIFEmpresa)
        })
        let response
        if (consulta) {
          response = await cancelConsultaCourtesyDaysAEAT(idCIFS)
        } else {
          response = await cancelCourtesyDaysAEAT(idCIFS)
        }
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        await this.applyFilters()
      }
    },
    executeActionHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const idCIFS = []
        const selected = this.selected
        const IdAccion = this.selectedAction.id
        const boolAccion = this.selectedAction.activo
        selected.forEach((s) => {
          idCIFS.push(s.IdCIFEmpresa)
        })
        this.$store.commit('setIsLoading', true)
        const response = await updateStateCompanies({ idCifsEmpresa: idCIFS, accion: IdAccion, valor: boolAccion })
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        await this.applyFilters()
      }
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang='scss' scoped>

</style>
